// extracted by mini-css-extract-plugin
export default {"wrapper":"NoData_wrapper__+UBox"};